import { JobClassDesignation } from './job-class-designation.model';

export interface TransferManPowerDetails {
  ManPowerReqDetailId?: string;
  RecruiterIdFrom?: string;
  RecruiterIdTo?: string;
  DispatchStatusId?: number;
  JobClasses: Array<JobClassDesignation>;
  StatusRestrictions: Array<number>;
}
